export enum ERoutes {
    "dashboard" = "/dashboard",

    "onboarding" = "/onboarding",

    "accounts" = "/accounts",

    "assets" = "/assets",
    "templateDetails" = "/assets/templates/:templateId/details",
    "templateSharing" = "/assets/templates/:templateId/details/sharing",

    "systemEmail" = "/account/system-emails",
    "billing" = "/account/plans-and-billing",

    "accountProfile" = "/account",
    "users" = "/account/users",
    "userProfile" = "/account/users/:userId",
    "senders" = "/account/senders",
    "suppressionList" = "/account/suppression-list",
    "export" = "/account/exports",
    "domainTracking" = "/account/tracking",
    "systemEmails" = "/account/systemEmails",

    "emailAPI" = "/email-api",
    "emailMetrics" = "/email-api/metrics",
    "emailDeliverability" = "/email-api/deliverability",
    "emailReports" = "/email-api/reports",
    "emailRequestLog" = "/email-api/requestLog",

    "apiGettingStarted" = "/email-api/doc/getting-started",
    "apiReferences" = "/email-api/doc/references",

    "lists" = "/contacts",
    "createList" = "/lists/default/manage/new",
    "importContacts" = "/contacts/import/list",
    "addContacts" = "/contacts/import/add-contacts",
    "contactDetails" = "/contacts/:contactId/:listId",

    "createSegment" = "/contacts/segments/create",

    "campaigns" = "/campaigns",
    "campaignDrafts" = "/campaigns/drafts",
    "campaignOutbox" = "/campaigns/outbox",
    "campaignSent" = "/campaigns",
    "campaignReport" = "/campaigns/:campaignId/stats/performance",
    "campaignsCreate" = "/campaigns/create",
    "campaignEdit" = "/campaigns/:campaignId/edit",

    "campaignsABCreate" = "/campaigns/abtests/create",
    "campaignsABTest" = "/campaigns/abtests",

    "templates" = "/campaigns/templates",
    "templateEdit" = "/campaigns/templates/:templateId/edit",
    "templateBrowse" = "/campaigns/templates/browse",

    "automations" = "/automations",
    "createAutomation" = "/automations/create",

    "forms" = "/forms",
    "formEdit" = "/forms/:formId/linked-form",
    "createForm" = "/forms/create",

    "brand" = "/brand",

    "stripeIntegration" = "/stripe",

}